import styled from "styled-components";

const Masonry = styled.div`
  // fix unwanted left margin caused by masonry library
  margin-inline: calc(${(p) => p.theme.spacing.xxs} * -1);
`;

export { Masonry };
